// "Zuletzt verwendet" (Material): Chip-Zeile unter der Materialsuche (MaterialSearch) und im
// Komponenten-Picker des Auftragsdetails — Mechaniker greifen immer wieder zu denselben Teilen.
// Quelle: recency.js (user_preferences); verschwindet ohne Historie.
import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../core/ui/ThemeContext';
import { useLanguage } from '../../../core/i18n/LanguageContext';
import { getRecent, recordRecent } from '../recency';

/**
 * @param {Function} onPick — ({materialId, description, baseUnit}) => void; Klick bumpt die Recency
 * @param {number} [max]
 */
function RecentMaterialChips({ user, onPick, max = 10 }) {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    getRecent(user, 'materials').then((list) => { if (alive) setItems(list); });
    return () => { alive = false; };
  }, [user]);

  const visible = items.slice(0, max);
  if (visible.length === 0) return null;

  const pick = (m) => {
    recordRecent(user, 'materials', m, 'materialId'); // bump, fire-and-forget
    onPick(m);
  };

  return (
    <div className="mt-2">
      <span className={`text-xs w-full block mb-1.5 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>
        {t('pm.recent.title')}:
      </span>
      <div className="flex flex-wrap gap-1.5">
        {visible.map((m) => (
          <button
            key={m.materialId}
            onClick={() => pick(m)}
            className={`text-sm rounded-full px-3 py-1.5 border text-left transition-colors ${isDarkMode
              ? 'bg-white/[0.08] text-white/80 border-white/15 hover:bg-white/[0.12]'
              : 'bg-slate-50 text-slate-700 border-slate-200 hover:border-brand/40'
            }`}
          >
            {m.description || m.materialId}
          </button>
        ))}
      </div>
    </div>
  );
}

export default RecentMaterialChips;
